import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';

import styles from './SearchByRedemtionIdOrReferanceCode.module.scss';

const SearchByRedemtionIdOrReferanceCode = (props) => {
  const { onSubmit, onChange, value, placeholder, onClean, searchKey } = props;
  const [iconState, setIconState] = useState('SEARCH');

  const handleOnSubmit = (event) => {
    event.preventDefault();
    setIconState('CLEAR');
    onSubmit(event);
  };
  const handleOnChange = (data) => {
    setIconState('SEARCH');
    onChange(data);
  };
  const handleOnClear = () => {
    setIconState('SEARCH');
    onClean && onClean();
  };

  useEffect(() => {
    //eslint-disable-next-line
    setIconState(searchKey ? 'CLEAR' : 'SEARCH');
  }, [placeholder]);

  useEffect(() => {
    if (!value) {
      setIconState('SEARCH');
    }
  }, [value]);

  return (
    <div className={styles.root__div}>
      <form onSubmit={handleOnSubmit} className={styles.root_form}>
        <FontAwesomeIcon icon={faSearch} className={styles.icon} />
        <input
          type='text'
          className={styles.input}
          value={value}
          onChange={handleOnChange}
          placeholder={placeholder}
          aria-label={placeholder}
        />
        {iconState === 'SEARCH' ? (
          <button
            className={styles.button}
            type='button'
            onClick={handleOnSubmit}
          >
            Search
          </button>
        ) : (
          <button
            className={`${styles.button} ${styles.buttonClear}`}
            type='button'
            onClick={handleOnClear}
          >
            Clear
          </button>
        )}
      </form>
    </div>
  );
};
export default SearchByRedemtionIdOrReferanceCode;
